import { Ray3 } from "./ray_types";

export function point_on_ray(ray: Ray3, t: number): Float32Array {
  return new Float32Array([
    ray.origin[0] + ray.direction[0] * t,
    ray.origin[1] + ray.direction[1] * t,
    ray.origin[2] + ray.direction[2] * t,
  ]);
}